import { useToasts } from 'react-toast-notifications';
import { useSelector } from 'react-redux';
import { SubmitHandler, useForm } from 'react-hook-form';
import { selectPresentMeta } from '../../../redux/meta';
import { useAppDispatch } from '../../../pages/assessment';
import {
  selectMedicalInfoAnswers,
  updateAssessment,
} from '../../../redux/assessment';
import { DispatchUpdateAssessmentInput } from '../../../redux/types';
import {
  AssessmentButtons,
  AssessmentCard,
  ControlledTextField,
} from '../shared';
import { rules } from '../demographics/rules';

type FormValues = {
  insuranceId: string;
};

const InsuranceId = () => {
  const dispatch = useAppDispatch();
  const meta = useSelector(selectPresentMeta);
  const medicalInfoAnswers = useSelector(selectMedicalInfoAnswers);
  const insuranceId =
    medicalInfoAnswers?.MI_InsuranceId?.length > 0
      ? medicalInfoAnswers.MI_InsuranceId[0]
      : '';
  const { addToast } = useToasts();

  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useForm<FormValues>({
    mode: 'onBlur',
  });

  const onSubmit: SubmitHandler<FormValues> = async data => {
    try {
      const answer: DispatchUpdateAssessmentInput = [
        { questionCode: meta.screen, answerValue: [data.insuranceId] },
      ];
      await dispatch(updateAssessment(answer));
    } catch (e) {
      addToast(
        'Sorry, something went wrong. Please refresh the page and try again.',
        { appearance: 'error' }
      );
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <AssessmentCard>
        <ControlledTextField<FormValues>
          name="insuranceId"
          control={control}
          rules={rules.insuranceId}
          label="Member ID"
          inputProps={{ maxLength: 50 }}
          defaultValue={insuranceId ?? ''}
        />
      </AssessmentCard>
      <AssessmentButtons
        primary={{
          children: 'Continue',
          type: 'submit',
          disabled: !isValid || isSubmitting,
          loading: isSubmitting,
        }}
      />
    </form>
  );
};

export default InsuranceId;
